import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function BrandShowcase() {
  return (
    <section
      className="section-pad bg-ohana-bg"
      data-testid="brand-showcase-section"
    >
      <div className="container-ohana">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-5">
            <p className="overline">Property Transitions</p>
            <h2
              className="h-display text-4xl md:text-5xl mt-3 leading-tight"
              data-testid="brand-showcase-headline"
            >
              Ready for your next chapter?
            </h2>
            <p className="mt-5 text-ohana-text-muted text-base md:text-lg leading-relaxed">
              Whether you&apos;re downsizing, settling an estate, or prepping a property for sale, we handle the heavy lift so you can move forward. Photo-based quotes, donation-conscious sorting, and a crew that shows up on time.
            </p>
            <p className="mt-4 text-ohana-text leading-relaxed">
              <span className="font-semibold text-ohana-primary">Expert property transitions, simplified.</span> One call. One team. Done in 24-48 hours for most jobs.
            </p>
            <div className="mt-8">
              <Link
                to="/contact"
                className="btn-primary"
                data-testid="brand-showcase-cta"
              >
                Get Your Free Consultation
                <ArrowUpRight className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-ohana-primary/10 ring-1 ring-ohana-border bg-white">
              <img
                src="/ohana/next-chapter.jpg"
                alt="Ohana Property & Transition Services. Ready for Your Next Chapter? Expert property transitions, simplified."
                className="w-full h-auto block"
                loading="lazy"
                data-testid="brand-showcase-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
